var _linearGradient, _linearGradient2, _linearGradient3, _polyline, _rect, _line, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeClass48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper_gradient",
    "data-name": "paper gradient",
    x1: 3.5,
    y1: 0.5,
    x2: 16.5,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5415,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper_gradient-2",
    x1: 27.5,
    y1: 18.5,
    x2: 40.5,
    y2: 31.5,
    xlinkHref: "#paper_gradient"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dark_Blue_Grad",
    "data-name": "Dark Blue Grad",
    x1: 27.5,
    y1: 34.5,
    x2: 40.5,
    y2: 47.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73b4c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1747,
    stopColor: "#6aaec3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4567,
    stopColor: "#529eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#2c839f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147391"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "10 13.5 10 41 27.5 41",
    fill: "none",
    stroke: "#969696",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 0.5,
    width: 13,
    height: 13,
    stroke: "#464646",
    strokeMiterlimit: 10,
    fill: "url(#paper_gradient)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 25,
    x2: 27.5,
    y2: 25,
    fill: "none",
    stroke: "#969696",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 18.5,
    width: 13,
    height: 13,
    stroke: "#464646",
    strokeMiterlimit: 10,
    fill: "url(#paper_gradient-2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 34.5,
    width: 13,
    height: 13,
    stroke: "#464646",
    strokeMiterlimit: 10,
    fill: "url(#Dark_Blue_Grad)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeClass48);
export default __webpack_public_path__ + "static/media/typeClass48.5c11ac5e9223f7fc7aaf626359635c4b.svg";
export { ForwardRef as ReactComponent };